export default {
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  "design-studio": () => import("/app/layouts/design-studio.vue").then(m => m.default || m),
  "furniture-companies": () => import("/app/layouts/furniture-companies.vue").then(m => m.default || m),
  offer: () => import("/app/layouts/offer.vue").then(m => m.default || m),
  "offer-new": () => import("/app/layouts/offer/new.vue").then(m => m.default || m)
}